import {CustomStreamEvent} from "./CustomStreamEvent";
import {LiveStadiumStreamEvent} from "./LiveStadiumStreamEvent";
import {ActiveRecord} from "../ActiveRecord";
export {StreamVideo} from './StreamVideo';
export {StreamEventStatusType} from './CustomStreamEvent';
export {VoDEvent} from './VoDEvent';
export enum StreamProvider {
  livestream,
  custom
}

export function streamProviderFactory(provider) {
  switch (provider) {
    case 'custom':
      return CustomStreamEvent;
    default:
      return LiveStadiumStreamEvent;
  }
}



// WEBPACK FOOTER //
// ./src/api/stream/index.ts